// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__3hw-I","logo":"sidebar_logo__3kM1Y","sections":"sidebar_sections__AQ7G2","marker":"sidebar_marker__1a5ns","button":"sidebar_button__2s7aD"};